<template>
  <div v-if="visible" class="promotion-mask">
    <x-dialog
      class="promotion"
      title="升变"
      :visible="visible"
      :show-close="false"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <!-- 升变棋子选择 -->
      <div class="promotion-main flex justify-between items-center">
        <div
          :class="
            'promotion-item cursor-pointer select-none flex  justify-center items-center ' +
              (selected === item.key ? 'selected' : '')
          "
          v-for="item in promotions"
          :key="item.key"
          @click="onClick(item)"
        >
          <img
            class="promotion-item__img select-none"
            :src="promotion(item.key)"
            :alt="item.key"
          />
        </div>
      </div>
      <!-- 取消 & 确认 -->
      <div class="footer text-center">
        <x-button @click="onOk">确定</x-button>
      </div>
    </x-dialog>
  </div>
</template>

<script>
import XDialog from '@/render/components/common/dialog'
import XButton from '@/render/components/common/button'

export default {
  name: 'Promotion',
  props: {
    visible: { type: Boolean, default: false },
    turn: {
      type: String,
      default: 'w',
    },
  },
  data() {
    return {
      selected: 'q',
      promotions: [
        {
          key: 'q',
        },
        {
          key: 'b',
        },
        {
          key: 'n',
        },
        {
          key: 'r',
        },
      ],
    }
  },
  components: { XDialog, XButton },
  computed: {
    promotion({ turn }) {
      return function(key = '') {
        return '/assets/themes/default/' + turn + key.toUpperCase() + '.png'
      }
    },
  },
  watch: {
    visible(val) {
      if (val) this.selected = 'q'
    },
  },
  async mounted() {},
  methods: {
    onCancel() {
      this.$emit('close')
    },
    onOk() {},
    onClick({ key }) {
      this.selected = key
    },
  },
}
</script>

<style lang="scss" scoped>
.promotion {
  &-mask {
    position: fixed;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba($color: #000000, $alpha: 0.8);
    z-index: 99;
  }
  &-main {
    padding: val(80) val(40) val(100);
  }
  &-item {
    width: val(142);
    height: val(165);
    background: rgba(114, 107, 115, 0.2);
    border: 1px solid #aea1af;
    border-radius: val(10);
    transition: all 0.3s;
    margin-right: val(24);
    &:last-of-type {
      margin: 0;
    }
    &__img {
      height: 80%;
    }
    &.selected {
      background-color: #3a2c3d;
    }
  }
}
</style>
